module.exports = __webpack_public_path__ + "static/media/WU_STEPS_sender_active.7d2fe563.svg";